<template>
  <div class="news">
    <banner title="NEW" />
    <div class="news-section">
      <div class="news-section-content">
        <div class="content-nav">
          <div
            class="content-nav-btn"
            :class="{'content-nav-active': newstype == 1}"
            @click="newstype = 1"
          >
            <span>Company News</span>
          </div>
          <div
            class="content-nav-btn"
            :class="{'content-nav-active': newstype == 2}"
            @click="newstype = 2"
          >
            <span>Industry dynamics</span>
          </div>
        </div>

        <div class="content-nav-item">
          <div class="item-list" v-for="(item, index) in newsList" :key="index">
            <img class="item-img" :src="`./img1/${item.Img}`" alt="新闻图片" />
            <p class="item-list-title">{{ item.Title }}</p>
            <p class="item-list-content">{{ item.Content }}</p>
            <div class="item-list-more">
              <router-link
                class="text-decoration"
                :to="{ name: 'newsdetails', params: { id: item.Id } }"
              >
                <img src="../assets/img/sanjiao.png" />
                <span>more</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  name: "news",
  components: {
    Banner
  },
  data() {
    return {
      newsList: [
        {
          Id: 1,
          Img: 'ac90aca0-aa2f-4ce8-813c-72c8cc9405a5.png',
          Title: 'Carlo Bozotti and Adalio T. Sanchez Elected to Avnet’s Board of Directors',
          Content: 'PHOENIX--(BUSINESS WIRE)--Leading global technology solutions provider Avnet (Nasdaq: AVT) today announced that Carlo Bozotti and Adalio T. Sanchez have been elected to the company’s Board of Director...'
        },
        {
          Id: 2,
          Img: 'home_do.jpg',
          Title: 'TI Vice President Dave Pahl to speak at UBS investor conference',
          Content: 'DALLAS, Nov. 21, 2019 /PRNewswire/ -- Texas Instruments Incorporated (TI) (Nasdaq: TXN) Vice President Dave Pahl will speak at the UBS Global TMT Conference in New York City on Tuesday, December 10, a...'
        },
        {
          Id: 3,
          Img: 'home_top.jpg',
          Title: 'Analog Devices Unveils Robust, Low-Latency PHY Technology for New ADI Chronous™ Portfolio of Industrial Ethernet Solutions',
          Content: 'Analog Devices, Inc. (ADI) announces the release of new robust, industrial Ethernet physical layer (PHY) products to help manufacturers address key Industry 4.0 and smart factory communication challen...'
        }
      ],
      newstype: 1
    };
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.news {
  width: 100%;
  height: 100%;
  background-color: #14679f;
  position: relative;
  overflow: hidden;

  &-section {
    width: 100%;
    &-content {
      width: 1240px;
      margin: 0 auto;
      background-color: #fff;

      .content-nav {
        width: 400px;
        height: 55px;
        margin: 0 auto;
        display: flex;
        align-items: center;

        &-btn {
          width: 50%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #e4e4e4;
          transition: all 0.2s;
        }

        .content-nav-active {
          background-color: red;
          color: #fff;
        }
      }

      .content-nav-item {
        width: 1070px;
        margin: 0 auto;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;

        .item-list {
          width: 330px;
          height: 500px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin: 10px 10px;
          border: 1px solid #15669e;

          &:hover {
            border: 1px solid #fff;
            box-shadow: 0 0 5px 2px #bfd3e0;
          }

          .item-img {
            width: 300px;
            height: 210px;
            background-color: #cecece;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
          }

          &-title {
            width: 300px;
            height: 160px;
            color: #15669e;
            font-size: 22px;
            padding: 0 10px;
            margin: 20px 0;
            overflow: hidden;
            text-overflow: ellipsis;
            border-left: 1px solid #15669e;
          }

          &-content {
            width: 273px;
            height: 100px;
            font-size: 14px;
            color: gray;

            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 5;
            -webkit-box-orient: vertical;
          }

          &-more {
            width: 273px;
            padding-top: 20px;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            img {
              width: 12px;
              height: 12px;
            }
            span {
              color: #e13834;
              padding: 0 5px;
            }
          }
        }
      }
    }
  }
  .text-decoration {
    text-decoration: none;
  }
}
</style>
